import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import Card from '@/components/Card';
import { Container as CardContainer } from '@/components/Card/styles';
import { Button } from '@/components/Button';

export * from '../styles';

export const HopsProgressBar = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== '$isComplete',
})<{ $isComplete: boolean }>(({ theme, $isComplete }) => ({
  height: 8,
  borderRadius: 6,
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.08)'
      : 'rgba(0, 0, 0, 0.06)',
  border: `1px solid ${
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.06)'
      : 'rgba(0, 0, 0, 0.04)'
  }`,
  '& .MuiLinearProgress-bar': {
    background: $isComplete
      ? 'linear-gradient(90deg, #00CFFF 0%, #22C55E 100%)'
      : 'linear-gradient(90deg, #EF4444 0%, #DC2626 100%)',
    boxShadow: $isComplete
      ? '0 0 12px rgba(0, 207, 255, 0.45)'
      : '0 0 12px rgba(239, 68, 68, 0.45)',
    borderRadius: 6,
    transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
  },
}));

export const HopCard = styled(CardContainer, {
  shouldForwardProp: (prop) => prop !== '$expanded',
})<{ $expanded: boolean }>`
  display: flex;
  width: 100%;
  gap: 8px;

  flex-direction: ${({ $expanded }) => ($expanded ? 'column' : 'row')};
  align-items: ${({ $expanded }) => ($expanded ? 'stretch' : 'center')};
`;

export const ExpandButton = styled(IconButton)<{
  $expanded: boolean;
  $isSm: boolean;
}>`
  margin-left: auto;
  transition: ${({ theme }) =>
    theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    })};

  ${({ $expanded }) =>
    $expanded
      ? `      
        transform: rotate(180deg);
        align-self: flex-end;
        margin-top: 16px;
        margin-left: 0;
      `
      : ` 
        align-self: center;
        margin-top: 0;
        margin-left: auto;
      `}
  flex-shrink: 0;
  display: ${({ $isSm }) => ($isSm ? 'none' : 'flex')};
`;

export const HopStackColumn = styled(Stack)`
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }

  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
`;

export const HopStackRow = styled(Stack)`
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }

  flex-direction: row;
  width: 100%;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  flex-wrap: nowrap;
  padding: 20px 0;
`;

export const MapToggleButton = styled(Button)`
  min-width: 160px;
  line-height: 0px;
  max-height: 38px;
`;

export const MapCardWrapper = styled(CardContainer)`
  height: 700px;
  width: 100%;
  padding: 0;
  overflow: hidden;
`;

export const MapStack = styled(Stack)({
  height: '100%',
  width: '100%',
});
